import { EmploymentStatus } from '@getpopsure/private-health-insurance-pricing-engine';
import {
  EmploymentStatus as PublicEmploymentStatus,
  getContributionPrices,
} from '@getpopsure/public-health-insurance-pricing-engine';

export const getAgeFromBirthYear = (birthYear: number) =>
  new Date().getFullYear() - birthYear;

export const privateToPublicEmploymentStatusMapping: Record<
  EmploymentStatus,
  PublicEmploymentStatus
> = {
  EMPLOYED_IN_GERMANY: 'EMPLOYED',
  EMPLOYED_OUTSIDE_OF_GERMANY: 'SELF_EMPLOYED',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  // The public health pricing engine returns undefined for "OTHER", so in order to be able to show an approximate price, use the "SELF_EMPLOYED" value instead
  OTHER: 'SELF_EMPLOYED',
};

export const getPublicHealthContribution = ({
  birthYear,
  income,
  employmentStatus,
}: {
  birthYear: number;
  income: number;
  employmentStatus: EmploymentStatus;
}) => {
  const publicEmploymentStatus =
    privateToPublicEmploymentStatusMapping[employmentStatus];

  const age = getAgeFromBirthYear(birthYear);

  const contributionPrices = getContributionPrices({
    provider: 'TK',
    age,
    monthlyIncome: income / 12,
    employmentStatus: publicEmploymentStatus,
  });

  const selfEmployedContributionPrices = getContributionPrices({
    provider: 'TK',
    age,
    monthlyIncome: income / 12,
    employmentStatus: 'SELF_EMPLOYED',
  });

  if (!contributionPrices || !selfEmployedContributionPrices) return null;

  const employerContribution =
    publicEmploymentStatus === 'EMPLOYED'
      ? selfEmployedContributionPrices.total - contributionPrices.total
      : 0;

  return {
    tariffName: 'Public',
    ...contributionPrices,
    employerContribution,
    tariffTotal: contributionPrices.total + employerContribution,
  };
};

export const getEligibilityForShortTerm = ({
  isPlanningToStayMoreThan5Years,
  hasPermanentResidencyPermit,
  hasEUPassport,
}: {
  isPlanningToStayMoreThan5Years?: boolean;
  hasPermanentResidencyPermit?: boolean;
  hasEUPassport?: boolean;
}) => {
  if (
    isPlanningToStayMoreThan5Years === undefined ||
    hasPermanentResidencyPermit === undefined ||
    hasEUPassport === undefined
  ) {
    return false;
  }

  return (
    !isPlanningToStayMoreThan5Years &&
    !hasPermanentResidencyPermit &&
    !hasEUPassport
  );
};
